/* eslint-disable array-bracket-newline */
/* eslint-disable space-before-function-paren */
const { isValidEmail } = require('./helpers');

function handleClientNav() {
  const activeClass = '-active';
  const errorClass = '-error';
  const mobileMenu = document.querySelector('.mobile-menu');
  const mobileMenuTrigger = document.querySelector('.menu-button-wrapper');
  const mobileMenuSubTrigger = [...document.querySelectorAll('.has-sub > .category-item-link')];
  const desktopMenuSubTrigger = [
    ...document.querySelectorAll('.header-menu-bar__menu-item, .header-menu__item.has-submenu'),
  ];

  const forms = [...document.querySelectorAll('form.jsx-2169253170')];

  function removeFocusStyle() {
    const intercomLogoButton = document.querySelector('a.header-logo-link.jsx-3633803079');

    const removeStyle = () => {
      intercomLogoButton.classList.add('border-none');
    };

    const addStyle = () => {
      intercomLogoButton.classList.remove('border-none');
    };

    intercomLogoButton.addEventListener('click', removeStyle);

    intercomLogoButton.addEventListener('mouseover', removeStyle);

    intercomLogoButton.addEventListener('mouseout', () => {
      setTimeout(() => {
        addStyle();
      }, 2000);
    });

    // focus style occurs when user selects Tab key
    intercomLogoButton.addEventListener('keydown', (event) => {
      if (event.keyCode === 9) {
        addStyle();
      }
    });
  }

  function handleAriaChange(elem, aria) {
    elem.setAttribute(
      `aria-${aria}`,
      elem.getAttribute(`aria-${aria}`) === 'false' ? 'true' : 'false'
    );
  }

  function handleMobileToggle() {
    function handleToggle() {
      this.classList.toggle(activeClass);
      mobileMenu.classList.toggle(activeClass);
      handleAriaChange(mobileMenu, 'hidden');
    }

    mobileMenuTrigger.addEventListener('click', handleToggle);
  }

  function handleMobileSubToggle() {
    function handleToggle() {
      this.classList.toggle(activeClass);

      const chevronElem = this.querySelector('.chevron');
      chevronElem.classList.toggle(activeClass);

      const subElem = this.nextElementSibling;

      if (!this.classList.contains(activeClass)) {
        $(subElem).animate(
          {
            height: 0,
          },
          250
        );
      } else {
        $(subElem).animate(
          {
            height: $(this).get(0).scrollHeight,
          },
          250,
          function() {
            $(this).height('auto');
          }
        );
      }
    }

    for (let i = 0; i < mobileMenuSubTrigger.length; i++) {
      mobileMenuSubTrigger[i].addEventListener('click', handleToggle);
    }
  }

  function handleDesktopSubToggle() {
    function handleToggle(vis) {
      const subElem =
        this.querySelector('.header-menu-bar__menu-wrapper > ul') ||
        this.querySelector('.header-menu__submenu-wrapper > ul');

      if (!subElem) {
        return;
      }

      handleAriaChange(this.firstElementChild, 'expanded');
      subElem.style.display = vis === 'show' ? 'block' : 'none';
    }

    for (let i = 0; i < desktopMenuSubTrigger.length; i++) {
      desktopMenuSubTrigger[i].addEventListener('mouseover', function() {
        handleToggle.bind(this)('show');
      });
      desktopMenuSubTrigger[i].addEventListener('mouseout', function() {
        handleToggle.bind(this)('hide');
      });
    }
  }

  function handleFormSubmit() {
    function submitHandler(e) {
      e.preventDefault();
      const inputElem = this.querySelector('input');
      const email = inputElem.value;

      if (!isValidEmail(email)) {
        this.classList.add(errorClass);
        return;
      }

      const encodedEmail = encodeURIComponent(email);

      this.classList.remove(errorClass);

      window.location.href = `https://www.intercom.com/pricing?email=${encodedEmail}&email_submission_id&referrer=%2F`;
    }

    for (let i = 0; i < forms.length; i++) {
      forms[i].addEventListener('submit', submitHandler);
    }
  }

  function init() {
    handleMobileToggle();
    handleMobileSubToggle();
    handleDesktopSubToggle();
    handleFormSubmit();
    removeFocusStyle();
  }

  return init();
}

module.exports = handleClientNav;



// WEBPACK FOOTER //
// ./modules/handleClientHeader.js